var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[(_vm.base)?[_c('List',{directives:[{name:"show",rawName:"v-show",value:(_vm.list),expression:"list"}],ref:"list",attrs:{"is_publish":false}})]:_vm._e(),(_vm.detail)?_c('Detail',{on:{"refresh":_vm.refresh}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }